import { useState, useRef, useEffect } from "react";
import { categories } from "@/mocks/categories";

export default function CategoryDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={dropdownRef} className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-5 py-2.5 bg-foreground-900 text-background-50 rounded-full text-sm font-medium hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap cursor-pointer"
      >
        <span>Wybierz kategorię</span>
        <span className="w-4 h-4 flex items-center justify-center">
          <i className={`text-base ${isOpen ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"}`}></i>
        </span>
      </button>
      {isOpen && (
        <div className="absolute top-full mt-2 right-0 w-64 bg-background-50 border border-background-200 rounded-xl shadow-lg z-50 max-h-80 overflow-y-auto">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center justify-between px-4 py-3 text-sm text-foreground-900 hover:bg-background-100 transition-colors duration-150 cursor-pointer border-b border-background-100 last:border-b-0"
            >
              <span>{cat.name}</span>
              <span className="text-xs text-foreground-500">{cat.namePl}</span>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}